<template>
  <div>
    <FilePickerMobile ref="filePickerMobile" :open="uploadDialogOpened" @error="(files) => $emit('error', files)" @close="uploadFiles" @upload="uploadFiles"/>
    <FolderCreationModal :open="folderDialogOpened" @close="createFolder" @confirm="createFolder"/>

    <v-speed-dial  v-if="allowCreate || allowUpload" :value="fab" top right fixed  direction="bottom" transition="slide-y-reverse" >
      <template v-slot:activator>
        <v-btn v-model="fab" dark class="buttonColor mb-5" fab>
          <v-icon class="mdi-36px">mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-btn v-if="allowUpload" dark fab small class="buttonColor" @click="uploadDialogOpened = true;">
        <v-icon>mdi-cloud-upload</v-icon>
      </v-btn>
      <v-btn v-if="allowCreate" dark fab small class="buttonColor" @click="folderDialogOpened = true;">
        <v-icon >mdi-folder-upload</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
import FilePickerMobile from '@/components/file-picker-mobile/index.vue';
import FolderCreationModal from '@/components/folder-creation-modal/index.vue';

export default {
  name: 'MobileActions',
  components: { FilePickerMobile, FolderCreationModal },
  data: () => ({
    fab: false,
    folderDialogOpened: false,
    uploadDialogOpened: false,
  }),
  props: {
    allowCreate: {
      type: Boolean,
      required: true,
    },
    allowUpload: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    createFolder(paramsFolder) {
      this.folderDialogOpened = false;

      if (paramsFolder && paramsFolder.newName) {
        this.$emit('create-folder', paramsFolder);
      }
    },
    uploadFiles(paramsUpload) {
      this.uploadDialogOpened = false;

      if (paramsUpload && paramsUpload.files) {
        this.$emit('upload', paramsUpload);
      }
    },
  },
};
</script>

<style>
  .buttonColor{
    background-color: var(--v-error-base) !important;
  }
</style>
